<template lang="pug">
  .footer
    v-card(
      flat
      tile
      class="grey-light black--text text-center"
    )
      v-card-text.max-content.py-4
        v-row(align="center" justify="space-between")
          v-col.footer__col(cols="12" md="9")
            img.footer__logo(src="@/assets/img/svg/logo-white.svg")
          v-col.footer__col(cols="12" md="2")
            a(href="https://play.google.com/store/apps/details?id=br.com.isptotem&hl=pt-BR" target="_blank")
              img.google-play(src="@/assets/img/svg/g-play.svg")
          v-col.footer__col(cols="12")
            p.white--text Telefone: (44) 3015-8940 | comercial@isptotem.com.br
              br
              | Horário de atendimento: segunda à sexta-feira, das 08:00 às 12:00 e das 13:00 às 18:00      
      v-card-text.max-content.py-4.white--text
        | © {{ new Date().getFullYear() }} ISP Totem | Todos os direitos reservados | Desenvolvido por 
        a.white--text(href="https://www.sertelecom.com.br/" target="_blank") Ser Telecom
</template>

<script>
  export default {
    name: 'MainHeader',
    data: () => ({}),
  }
</script>

<style lang="sass" scoped>
@import "@/assets/style/mobileFirst.sass"

.footer
  .v-card 
    background: linear-gradient(#39456D 30%, #BF3F45)
    +media-min-md
      min-height: 350px
  &__col
    position: relative
    +media-min-md
      text-align: left
    .google-play
      text-align: center
      width: 40%
      +media-min-md
        width: 100%
        text-align: right
    p 
      +media-min-md
        font-size: 16px
  &__logo
    position: relative
    width: 25%
    +media-min-md
      bottom: -20px
</style>
